import { render, staticRenderFns } from "./BmvModal.vue?vue&type=template&id=36822c4d&scoped=true"
import script from "./BmvModal.vue?vue&type=script&lang=js"
export * from "./BmvModal.vue?vue&type=script&lang=js"
import style0 from "./BmvModal.vue?vue&type=style&index=0&id=36822c4d&prod&lang=css"
import style1 from "./BmvModal.vue?vue&type=style&index=1&id=36822c4d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36822c4d",
  null
  
)

export default component.exports